module.exports = __webpack_public_path__ + "847344897fe8a5b01c6adbade1acb65a.svg";